import Link from 'next/link';

import SitemapHTML from '~/components/SitemapHTML';

import { notifyBugSnag } from '~/utils/ErrorChecking';
import { fetchDirectoryHtmlSitemapStates } from '~/utils/Fetch/Location';
import Head from '~/components/Meta/Head';
import Breadcrumb from '~/components/Breadcrumb';
import ContentWrapper from '~/components/ContentWrapper';
import { provinces } from '~/utils/Provinces';
import styles from './agents-directory/index.module.scss';

const Index = (props) => {
  const { pageData } = props;
  const { locations } = pageData;

  const breadcrumb = {
    crumbs: ['RealEstateAgents.com', 'Province Directory'],
    asPath: ['/', '/province-directory'],
    pathname: ['/', '/province-directory'],
  };

  const renderLocations = () => {
    if (locations && locations.length > 0) {
      return locations.map((location) => (
        <span className={styles.directory__link}>
          <Link
            prefetch={false}
            href="/[state_slug]"
            as={`/${location.toLowerCase()}`}
          >
            {provinces.CA.find((province) => province.short.toLowerCase()
            === location.toLowerCase())?.name}
          </Link>
        </span>
      ));
    }
    return null;
  };

  return (
    <div className={styles.directory}>
      <Head
        url={`${process.env.CLIENT_ORIGIN}/province-directory`}
        title="Province Directory | RealEstateAgents.com"
        description="A directory of the of Canadian provinces"
      />
      <ContentWrapper>
        <Breadcrumb
          passedAsPath={breadcrumb && breadcrumb.asPath}
          passedPathname={breadcrumb && breadcrumb.pathname}
          passedCrumbs={breadcrumb && breadcrumb.crumbs}
          breadcrumbReady
          noCheck
        />
        <SitemapHTML
          breadcrumb={breadcrumb}
          title="Agents in Canada"
          description="Find the perfect real estate agent in any province."
          renderItems={renderLocations}
        />
      </ContentWrapper>
    </div>
  );
};

export async function getStaticProps(ctx) {
  try {
    const locations = await fetchDirectoryHtmlSitemapStates({ country: 'CA' });
    const pageData = {
      locations,
    };
    return {
      props: { pageData },
      revalidate: 60 * 5,
    };
  } catch (err) {
    console.log(err);
    const bugSnagMetadata = [
      {
        label: 'route',
        fields: {
          asPath: ctx.asPath,
          pathname: ctx.pathname,
          server_context: ctx,
          server: !!ctx.req,
        },
      },
    ];
    notifyBugSnag({ error: err, metadata: bugSnagMetadata });
    return { props: { pageData: {}, error: { code: 500 } }, revalidate: 1 };
  }
}

export default Index;
